import React from 'react'
import styled from "styled-components"

import topImg from "../../image/courses-top.JPG"

const CoursesTop = () => {

   return (
      <CoursesTopStyles className="pages-top" topImg={topImg}>
         <h2>コース</h2>
      </CoursesTopStyles>
   )
}

const CoursesTopStyles = styled.section`
   background-image: url(${({topImg}) => topImg});
   background-position: 0 25%;
`

export default CoursesTop